import { Chip, Tooltip } from "@mui/material";
import { Stack } from "@mui/system";
import { useTranslation } from "react-i18next";
import { InfectiousDiseaseLevelEnum, LiterFlowTypeEnum } from "../../common/enums";
import ItemLabel from "../ItemLabel/ItemLabel";
import Panel from "../Panel/Panel";

const ClinicalInformationPanel = ({ patientInfo, showSymptoms = true }) => {
  const { t } = useTranslation();

  if (!patientInfo) return null;

  return (
    <Panel title={t("PatientsDetails.clinicalInformation")} variant="outlined">
      <Stack spacing={1}>
        {patientInfo.tuberculosis && (
          <ItemLabel label="Tuberculosis" text={patientInfo.tuberculosis} />
        )}
        {patientInfo.diagnosis_codes?.length > 0 && (
          <ItemLabel
            label={t("PatientsDetails.diagnosisCode")}
            text={patientInfo.diagnosis_codes.map((diagnosisCode) => (
              <Tooltip
                key={diagnosisCode.diagnosis_code}
                title={<span>{diagnosisCode?.long_description}</span>}
                placement="right"
              >
                <Chip label={diagnosisCode?.diagnosis_code} sx={{ mr: 1 }} />
              </Tooltip>
            ))}
          />
        )}
        {patientInfo.liter_flow_min != null && patientInfo.liter_flow_min != undefined &&
          patientInfo.liter_flow_max != null && patientInfo.liter_flow_max != undefined && (
            <ItemLabel
              label={t("PatientsDetails.literFlow")}
              text={`${Number(patientInfo.liter_flow_min).toFixed(2)}-${Number(patientInfo.liter_flow_max).toFixed(2)}`}
            />
          )}
        {patientInfo.flow_type > 0 && (
          <ItemLabel
            label={t("PatientsDetails.literFlowType")}
            text={LiterFlowTypeEnum[patientInfo.flow_type]}
          />
        )}
        {patientInfo.ids_level !== null && (
          <ItemLabel
            label={t("PatientsDetails.recommendedPPEForTechnician")}
            text={InfectiousDiseaseLevelEnum[patientInfo.ids_level]}
          />
        )}
        {showSymptoms && patientInfo.patient_symptom?.length > 0 && (
          <ItemLabel
            label={t("PatientsDetails.symptoms")}
            text={patientInfo.patient_symptom.map(symptom => symptom.name).join(', ')}
          />
        )}
        {patientInfo.infectious_disease_level !== null && patientInfo.infectious_disease_notes && (
          <ItemLabel
            label={t("PatientsDetails.notes")}
            text={patientInfo.infectious_disease_notes}
          />
        )}
      </Stack>
    </Panel>
  );
};

export default ClinicalInformationPanel;
